import { Directive } from '@angular/core';

@Directive({
  selector: '[hsAntiForgeryToken]'
})
export class AntiForgeryTokenDirective {

  constructor() { }

}
